import loadable from "@loadable/component";


export default loadable(() => import(/* webpackChunkName: "errorModal.m" */ "./Loadable"));
